import React from "react";
import styles from "./user-table.module.scss";
import { IPage } from "../../../api/entities/page";
import Table, { IColumnDefinition } from "../../shared-ui/table/table";
import { IEnterpriseUser, IEnterpriseUserRequestParams, IEnterpriseUserSortField } from "../../../api/entities/enterprise-user";
import { Formatters } from "../../../helper/formatters";
import { EnterpriseConsoleUserPermission, InvitationStatus } from "../../../api/entities/invitation";
import { MoreOption } from "./moreoption";
import tableStyles from "../../shared-ui/table/table.module.scss";

export interface IInvitationTableProps {
    isLoading: boolean;
    page: IPage<IEnterpriseUser>;
    requestParams: IEnterpriseUserRequestParams;
    onRequestParamsChanged: (data: Partial<IEnterpriseUserRequestParams>) => void;
}

export function UserTable(props: IInvitationTableProps) {

    function getPermissionDescription(permission: EnterpriseConsoleUserPermission) {
        let getPermission = (desc: string) => {
            if ((permission & EnterpriseConsoleUserPermission[desc]) === EnterpriseConsoleUserPermission[desc]) {
                return desc;
            }
            return null;
        }

        let permissions = [
            getPermission("Read"),
            getPermission("Modify"),
            getPermission("Create"),
            getPermission("Delete"),
        ]
            .filter(x => !!x);

        return permissions;
    }

    const columns: IColumnDefinition<IEnterpriseUser, string>[] = [
        {
            label: "Email",
            className: styles["col--email"],
            formatter: row =>
                (<div>
                    {row.email}
                    {!row.isActivated && <span>&nbsp;(deactivated)</span>}
                    {!!row.invitation && row.invitation.status === InvitationStatus.Pending && <span>&nbsp;(invited)</span>}
                    {!!row.invitation && row.invitation.status === InvitationStatus.Expired && <span>&nbsp;(invitation expired)</span>}
                </div>),
            sortKey: IEnterpriseUserSortField.Email
        },
        {
            label: "Name",
            className: styles["col--email"],
            formatter: row => row.name,
            sortKey: IEnterpriseUserSortField.Email
        },
        {
            label: "Permission",
            className: styles["col--permission"],
            formatter: row => getPermissionDescription(row.permission).join(", "),
        },
        {
            label: "Member since",
            className: styles["col--invited-date"],
            formatter: row => Formatters.formatDateTime(row.createdAt),
            sortKey: IEnterpriseUserSortField.InvitedDate
        },
        {
            label: "Admin",
            className: styles["col--is-admin"],
            formatter: row => row.isAdmin ? "Yes" : "No",
        },
        {
            label: "Manage",
            className: tableStyles["col--manage"],
            formatter: row => (<MoreOption
                data={row}
                fetchData={() => props.onRequestParamsChanged({})}
            />),
        },
    ];

    return (
        <Table
            testId="invitation-table"
            hideCheckbox={true}
            columns={columns}
            rows={props.page.data}
            totalRows={props.page.count}
            loading={props.isLoading}
            requestParams={props.requestParams}
            onRequestParamsChanged={props.onRequestParamsChanged}
        />
    );
}
